import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const getFirestopLabelUploadSignedUrl = async ({
  projectId,
  labelId,
  fileName,
  contentType,
}) => {
  const apiPath = `firestop-documentation/project/${projectId}/firestop-labels/${labelId}/label-upload-signed-url`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { fileName, contentType },
  });

  const response = await axios(signedRequest);

  return response.data;
};
